import React, { useEffect, useRef, useState } from 'react';
import '../../App.css';
import {
  required,
  SelectInput,
  TextInput,
  useDataProvider,
  DateTimeInput,
  useRefresh,
  FormDataConsumer,
  AutocompleteInput
} from 'react-admin';
import { eventStatus } from '../../utils/choices';
import { appStyles, columnStyles } from 'styles';
import { BaseForm } from '../../Components';
import { ActionButton } from '../../Components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { EventPlotForm } from '../../../src/Components/Forms';
import CustomLocationDescForm from 'Components/Forms/CustomLocationDesc';
import { validateFourStringCode } from '../../../src/utils/validation';
const validateBypassCode = [required(), validateFourStringCode];

// Material-UI adds an extra div around AutoCompleteInput that sets a flex-grow: 1
// which pushing the component to the left. In order to disable need another wrapper to overwrite it
const useStyles = makeStyles({
  root: {
    flexGrow: 0,
  },
});

// Uses this form if an event director wants to update an event
const EventDetails = (props) => {
  const form = columnStyles('column', '30vw');
  const classes = appStyles();
  const autoCompleteStyle = useStyles();

  const [eventDate, setEventDate] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const refresh = useRefresh();

  const [locations, setLocations] = useState([]);
  const [locDescription, setLocDescription] = useState();

  const dataProvider = useDataProvider();
  const handleCompleteEvent = () => {
    const { record } = props;
    if (record.status !== 'COMPLETED') {
      setLoading(true);
      props.record.status = 'COMPLETED';
      dataProvider('UPDATE', 'event', {
        data: record,
      })
        .then(({ data }) => {
          setLoading(false);
          refresh();
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          refresh();
        });
    }
  };

  useEffect(() => {
    if (props.record.eventDate) {
      setEventDate(
        `${props.record.eventDate.date}T${props.record.eventDate.time}`
      );
    }
    if (props.record.status == 'COMPLETED') {
      setIsCompleted(true);
    }
    dataProvider
      .getList('location', {})
      .then(({ data }) => {
        const locArray = data.map(({ id, name }) => ({ id, name }));
        const locDescArray = data.map(({ id, description }) => ({ id, description }));
        setLocations(locArray);
        setLocDescription(locDescArray);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const childRef = useRef();

  const handleChildMethod = (event) => {
    const locDesc = locDescription.find((loc) => loc.id === event);

    childRef.current.changeLocationDescription(locDesc);
  };


  return (
    <BaseForm {...props} iscompleted={isCompleted} dialogContent='Are you sure want to delete this item?This will remove all associated evidences, suspects and supersleuths 123'>
      <div className={form.container}>
        <TextInput
          className={form.column}
          source="name"
          label="Event Title"
          validate={required()}
          disabled={isCompleted}
        />
        {props.record.plot ?
          <TextInput
            className={form.column}
            source="plot.name"
            label="Plot"
            validate={required()}
            disabled={true}
          />
          :
          <TextInput
            className={form.column}
            source="plot.name"
            label="Plot"
            validate={required()}
            disabled={isCompleted}
          />
        }

        <TextInput
          className={form.column}
          source="eventDirector.email"
          label="Event Director"
          validate={required()}
          disabled={isCompleted}
        />
        <div className={autoCompleteStyle.root}>

          <AutocompleteInput
            className={form.column}
            source="eventLocation.id"
            label="Location"
            choices={locations}
            validate={required()}
            disabled={isCompleted}
            onChange={handleChildMethod}
          />
        </div>
        <FormDataConsumer>
          {(formDataProps) =>
            <CustomLocationDescForm ref={childRef} {...formDataProps} />
          }
        </FormDataConsumer>

        <FormDataConsumer>
          {
            formDataProps => (
              <EventPlotForm  {...formDataProps} isSuperAdmin={false} iscompleted={isCompleted} />
            )
          }
        </FormDataConsumer>
        <SelectInput
          className={form.column}
          source="status"
          choices={eventStatus}
          validate={required()}
          disabled={isCompleted}
        />
        <TextInput
          className={form.column}
          source="eventCode"
          validate={required()}
          disabled={isCompleted}
        />
        <TextInput
          label="Sleuth Code"
          className={form.column}
          source="bypassCode"
          validate={validateBypassCode}
        />
        <DateTimeInput
          className={form.column}
          source="eventDateISO"
          label="Date / Time"
          disabled={isCompleted}
          format={(record) => {
            if (typeof record === 'string') {
              return record.slice(0, 19)
            }
            // console.log(typeof record, record.toISOString(), record);
            return record.toISOString()
          }}
          parse={(record) => {
            return record
          }}
        />
      </div>

      {!isCompleted ? (
        <ActionButton
          label="Complete Event"
          onClick={handleCompleteEvent}
          style={{ backgroundColor: 'green' }}
          icon={<FontAwesomeIcon icon={faCheckCircle} />}
        />
      ) : null}

      {loading ? (
        <CircularProgress size={20} className={classes.circularProgress} />
      ) : null}
    </BaseForm>
  );
};

export default EventDetails;
